import React from 'react';

import { Outlet } from 'react-router-dom';

const ItemRequestContent = () => {
  return <Outlet />;
};

export default ItemRequestContent;
